const scenario_date = [
  {//0
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"88b717ad-e047-493e-850b-ed128e5c73ce",
    "beforenodeX":149,
    "beforenodeY":57,
    "start_flg":true,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":2
    },
    "parameter":[],
    "mainmessage":"\u3053\u3061\u3089\u304b\u3089\u65e5\u7a0b\u8abf\u6574\u3092\u884c\u3046\u3053\u3068\u304c\u3067\u304d\u307e\u3059\u3002\n\u6b21\u306e\u8cea\u554f\u306b\u304a\u7b54\u3048\u3044\u305f\u3060\u3051\u307e\u3059\u3088\u3046\u304a\u9858\u3044\u3044\u305f\u3057\u307e\u3059\u3002",
    "status":2,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"34f3bfe0-d368-4867-8f01-b6a9cf666f25",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30154
  },
  {//1
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"34f3bfe0-d368-4867-8f01-b6a9cf666f25",
    "beforenodeX":150,
    "beforenodeY":178,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u540d\u524d",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"\u304a\u540d\u524d\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"8fa4493d-04bc-40e3-9a63-aae0bce59cf5",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30156
  },
  {//2
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"8fa4493d-04bc-40e3-9a63-aae0bce59cf5",
    "beforenodeX":521,
    "beforenodeY":182,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"Email",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"Email\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"2f68b3a4-d0c7-415c-b746-f7a5ebd16bd3",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30157
  },
  {//3
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"2f68b3a4-d0c7-415c-b746-f7a5ebd16bd3",
    "beforenodeX":911,
    "beforenodeY":180,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"TEL",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"\u96fb\u8a71\u756a\u53f7\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"627f9585-51ba-4879-b062-ed86fbc033c3",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30158
  },
  {//4
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"627f9585-51ba-4879-b062-ed86fbc033c3",
    "beforenodeX":1290,
    "beforenodeY":179,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u4f4f\u6240",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"\u4f4f\u6240\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"12a32e89-f84a-483d-9c73-0c74774a4859",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30159
  },
  {//5
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"12a32e89-f84a-483d-9c73-0c74774a4859",
    "beforenodeX":150,
    "beforenodeY":322,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$1[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"6402e58e-8284-4229-ab37-72400d6ead84",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30161
  },
  {//6
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"6402e58e-8284-4229-ab37-72400d6ead84",
    "beforenodeX":524,
    "beforenodeY":327,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$2[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"d0a71294-5a95-4c43-9cf3-9998089b9b4f",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30162
  },
  {//7
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"d0a71294-5a95-4c43-9cf3-9998089b9b4f",
    "beforenodeX":910,
    "beforenodeY":326,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$3[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"d87fa65a-f953-4d04-aca3-482c85f7c118",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30163
  },
  {//8
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"d87fa65a-f953-4d04-aca3-482c85f7c118",
    "beforenodeX":1291,
    "beforenodeY":327,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$4[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"1a8f0500-bcd0-4e41-b6f1-fd8822e7c678",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30164
  },
  {//9
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"1a8f0500-bcd0-4e41-b6f1-fd8822e7c678",
    "beforenodeX":1665,
    "beforenodeY":329,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$5[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"d64acd87-da46-460e-ab31-4004c68a687b",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30165
  },
  {//10
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"d64acd87-da46-460e-ab31-4004c68a687b",
    "beforenodeX":147,
    "beforenodeY":457,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":4
    },
    "parameter":{
      "title":"[HRMonster] \u65e5\u7a0b\u8a2d\u5b9a",
      "user_hash":[],
      "user_hash_sub":[],
      "user_hash_share":[],
      "holiday_list":[],
      "work_time_start":9,
      "work_time_end":18,
      "interval":0,
      "mtg_time":1,
      "count":3,
      "after":1,
      "period":0,
      "until":30,
      "is_AND":false,
      "public_holiday":false,
      "mtg_time_hour":1,
      "mtg_time_minute":0,
      "duplicate_num":0,
      "is_all_day":false
    },
    "mainmessage":"[calendar][/calendar]",
    "status":4,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"68681bf5-83dc-412b-8c06-62fb83fb4909",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30168
  },
  {//11
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"68681bf5-83dc-412b-8c06-62fb83fb4909",
    "beforenodeX":149,
    "beforenodeY":573,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":10
    },
    "parameter":{
      "title":"\u65e5\u7a0b\u8abf\u6574\u3055\u308c\u307e\u3057\u305f",
      "to":"",
      "cc":"",
      "after":0
    },
    "mainmessage":"<p>\u3054\u62c5\u5f53\u8005\u69d8</p><p><br></p><p>\u304a\u4e16\u8a71\u306b\u306a\u3063\u3066\u304a\u308a\u307e\u3059\u3002</p><p>\u65e5\u7a0b\u8abf\u6574\u3055\u308c\u305f\u65b9\u304c\u3044\u3089\u3063\u3057\u3083\u3044\u307e\u3059\u306e\u3067</p><p>\u3054\u78ba\u8a8d\u306e\u307b\u3069\u3088\u308d\u3057\u304f\u304a\u9858\u3044\u3044\u305f\u3057\u307e\u3059\u3002</p><p><br></p><p>---</p><p><br></p><p>\u304a\u540d\u524d\uff1a__applicant__</p><p>Email\uff1a__email__</p><p>TEL\uff1a__tel__</p>",
    "status":10,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"70863eea-9cfc-4cfa-a99c-16de8e032609",
        "point":""
      }
    ],
    "template":"",
    "is_cv":true,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30188
  },
  {//12
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"70863eea-9cfc-4cfa-a99c-16de8e032609",
    "beforenodeX":151,
    "beforenodeY":670,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":0
    },
    "parameter":[],
    "mainmessage":"\u3054\u8a18\u5165\u9802\u304d\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3057\u305f\u3002\n\u62c5\u5f53\u304b\u3089\u3054\u9023\u7d61\u3044\u305f\u3057\u307e\u3059\u306e\u3067\u4eca\u3057\u3070\u3089\u304f\u304a\u5f85\u3061\u304f\u3060\u3055\u3044\u3002",
    "status":0,
    "select":[
      {
        "msg_type":"button",
        "message":"\u6700\u521d\u3078\u623b\u308b",
        "text_option":"white",
        "next_node":"8bb9e47c-ccc1-4e5c-9e29-878fb0b3b26a",
        "point":"0"
      }
    ],
    "template":"[button]\u6700\u521d\u3078\u623b\u308b,white[/button]",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "pk":30166
  },
  {//13
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"8bb9e47c-ccc1-4e5c-9e29-878fb0b3b26a",
    "beforenodeX":546,
    "beforenodeY":726,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":9
    },
    "parameter":[],
    "mainmessage":"[restart][/restart]",
    "status":9,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30167
  }
]

export {
  scenario_date
}


// WEBPACK FOOTER //
// ./src/assets/data/tutorial_scenario_date.js